import { State } from 'features/Frames/types';

export const statusHeaderWriter = (state: State): string => {
  switch (state) {
    case State.OK:
      return `Delivery is as expected`;
    case State.LOW_DELIVERY:
      return `Low Delivery`;
    case State.IN_ERROR:
      return `Stopped delivering - Error`;
    case State.MIA:
      return `Stopped delivering - MIA`;
    default:
      return `Deactivated`;
  }
};
